import { RadioField, SubmitFormButton, useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { createPortal } from 'react-dom';
import { SettingsModalFooterActions } from 'features/settings_modal/footer_actions';
import { useSettingsModalLayoutOptional } from 'features/settings_modal/layout_context';
import { FormFooter } from '../styles';
const formFieldsContainerCss = "fuszw72";
export const FormContent = () => {
  const {
    handleReset,
    submitForm,
    resetForm
  } = useFormContext();
  const {
    showFooterHost,
    footerHost
  } = useSettingsModalLayoutOptional() ?? {};
  return <>
      <div className={formFieldsContainerCss}>
        <RadioField label={I18n.t('publisher.organization_settings.invitations.enabled_for.admins_and_group_admins')} name="invitation_permissions_enabled_for" value="group_admin" />
        <RadioField label={I18n.t('publisher.organization_settings.invitations.enabled_for.admins_only')} name="invitation_permissions_enabled_for" value="admin" />
      </div>
      {showFooterHost ? footerHost != null && createPortal(<SettingsModalFooterActions onSave={submitForm} onCancel={resetForm} />, footerHost) : <FormFooter>
            <Button appearance="secondary-outline" onClick={handleReset}>
              {I18n.t('publisher.action.cancel')}
            </Button>
            <SubmitFormButton>
              {I18n.t('publisher.action.save')}
            </SubmitFormButton>
          </FormFooter>}
    </>;
};

require("./form_content.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_content.js");